import { Component, Input } from '@angular/core';
import { ChartConfig, InpageAliasService, OmniDashboard } from 'src/app/my-sedgwick';
import { BaseComponent, LoadingState } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-return-to-work-card',
    template: `
    <app-panel
      title="Returning to work"
      [labelTemplate]="details"
      [headerLevel]="2"
      class="tw-cursor-pointer"
      (click)="
        FeatureLogging('ReturnToWork', 'Returning to work', 'Summary View Card')
      "
      routerLink="/summary/return-to-work"
      [canExpand]="false"
      tabindex="-1"
      >
      <ng-template #details>
        <div class="tw-w-full tw-flex tw-justify-end">
          @if (omniDashboard) {
            <a
              class="tw-flex tw-items-center"
              routerLink="/summary/return-to-work"
              aria-label="Go to Employees returning to work details page"
              >
              <div class="app-pr1  ">{{ 'DETAILS' | translation: translationRequest }}</div>
            </a>
          }
        </div>
      </ng-template>
      <div class="tw-h-[345px]">
        <app-loading-panel
          loadingStyle="Box"
          [loadingHeight]="300"
          [state]="loadingState"
          [error]="error"
          class="tw-h-full"
          >
          <ng-template #empty>
            <div
              class="tw-flex tw-items-center tw-w-full tw-h-full tw-justify-around"
              >
              <app-empty-state-label
                icon="data_usage"
                header="No {{ employeeAlias }} found"
                >
              </app-empty-state-label>
            </div>
          </ng-template>
          <ng-template #content>
            <app-card-chart
              [config]="config"
              class="tw-h-full"
              [translationRequest]="translationRequest"
            ></app-card-chart>
          </ng-template>
        </app-loading-panel>
      </div>
    </app-panel>
    `,
    styles: [``],
    standalone: false
})
export class ReturnToWorkCardComponent extends BaseComponent {
  @Input()
  error: any;

  @Input()
  translationRequest: TranslationRequest;

  private _omniDashboard: OmniDashboard;

  employeeAlias: string;

  @Input()
  set omniDashboard(value: OmniDashboard) {
    this._omniDashboard = value;
    if (!value) {
      return;
    }

    this.loadingState =
      value.rtwFull + value.rtwPartial > 0 ? 'Loaded' : 'Empty';
    this.config = new ChartConfig()
      .addSeries('Full Day', value.rtwFull, '#3c8bf7')
      .addSeries('Reduced/Restricted Work', value.rtwPartial, '#ba49ad');
  }
  get omniDashboard(): OmniDashboard {
    return this._omniDashboard;
  }

  config: ChartConfig;

  loadingState: LoadingState = 'Loading';
   constructor(private aliases: InpageAliasService) {
    super();
  } 
  async ngOnInit() {
    this.employeeAlias = await this.aliases.get('employeePlural');
  }
}
